const memoryStore: Record<string, string> = {};
// タブ単位の値用。既存の memoryStore と混ぜない
const sessionMemoryStore: Record<string, string> = {};

function isStorageAvailable(storageType: 'localStorage' | 'sessionStorage'): boolean {
  const testKey = '__storage_test__';
  try {
    const storage = window[storageType];
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

const hasLocalStorage = isStorageAvailable('localStorage');
const hasSessionStorage = isStorageAvailable('sessionStorage');

const safeStorage = {
  getItem(key: string): string | null {
    if (hasLocalStorage) return localStorage.getItem(key);
    if (hasSessionStorage) return sessionStorage.getItem(key);
    return memoryStore[key] ?? null;
  },

  setItem(key: string, value: string): void {
    if (hasLocalStorage) {
      localStorage.setItem(key, value);
      return;
    }
    if (hasSessionStorage) {
      sessionStorage.setItem(key, value);
      return;
    }
    memoryStore[key] = value;
  },

  removeItem(key: string): void {
    if (hasLocalStorage) {
      localStorage.removeItem(key);
      return;
    }
    if (hasSessionStorage) {
      sessionStorage.removeItem(key);
      return;
    }
    delete memoryStore[key];
  },
};

const safeSessionStorage = {
  getItem(key: string): string | null {
    if (hasSessionStorage) return sessionStorage.getItem(key);
    return sessionMemoryStore[key] ?? null;
  },

  setItem(key: string, value: string): void {
    if (hasSessionStorage) {
      sessionStorage.setItem(key, value);
      return;
    }
    sessionMemoryStore[key] = value;
  },

  removeItem(key: string): void {
    if (hasSessionStorage) {
      sessionStorage.removeItem(key);
      return;
    }
    delete sessionMemoryStore[key];
  },
};

export default safeStorage;
export { safeSessionStorage };
